import { ScormContentClientBase, ScormClientOptions, ScormContentData } from './scorm-content-client-base';
import { ContentClientError } from './content-client-error';
import { UNEXPECTED_ERROR } from './constants';

/**
 * Implementation of SCORM content client for the Monorails (legacy) backend
 * Handles SCORM API communication with the monolithic LearnUpon backend
 */
export class ScormContentClient extends ScormContentClientBase<ScormContentData> {
  /**
   * Get SCORM data for course content
   * @param opts - Options containing enrollment_id, course_id and component_id
   * @returns Raw SCORM data response from the API
   * @throws ContentClientError if API errors occur
   */
  async getContentData(opts: ScormClientOptions): Promise<ScormContentData> {
    try {
      const scorm_token = await this.getToken('/enrollments/initiate_scorm_launch/0.json', opts);

      const launchUrl = this.buildLaunchUrl('/scorm_api/launch.json', scorm_token, opts);
      const response = await fetch(launchUrl);

      if (!response.ok) {
        throw new ContentClientError(`Failed to fetch SCORM data: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();

      if (!data || !data.scorm_content_location || !data.content_href) {
        throw new ContentClientError('Invalid SCORM data response format');
      }

      return {
        ...data,
        scorm_token,
      };
    } catch (error) {
      if (error instanceof ContentClientError) {
        throw error;
      }
      throw new ContentClientError(UNEXPECTED_ERROR, error);
    }
  }
}
